<template>
  <component :is="layout" class="content">
    <slot />
    <call-me-back-button></call-me-back-button>
    <call-me-back-modal></call-me-back-modal>

    <basket-button v-if="basketVisible"></basket-button>
    <basket-modal v-if="basketVisible"></basket-modal>
    <cookie-consent-modal></cookie-consent-modal>
  </component>
</template>

<script>
import { mapGetters } from "vuex";

const defaultLayout = "AppLayoutDefault";

const importedLayouts = {};

export default {
  name: "AppLayout",
  components: {
    CallMeBackModal: () => import("@/components/CallMeBackModal.vue"),
    CallMeBackButton: () => import("@/components/CallMeBackButton.vue"),
    BasketButton: () => import("@/components/basket/BasketButton.vue"),
    BasketModal: () => import("@/components/basket/BasketModal.vue"),
    CookieConsentModal: () => import("@/components/CookieConsentModal.vue"),
  },
  computed: {
    ...mapGetters({
      loggedIn: "session/isReady",
      hasActivePurchase: "purchase/hasActivePurchase",
    }),
    basketVisible() {
      return (
        this.loggedIn &&
        this.hasActivePurchase &&
        !this.$route.fullPath.includes("/checkout")
      );
    },
    layout() {
      const layout = this.$route.meta.layout || defaultLayout;

      // Avoid unnecessary re-render of layouts (dynamic component in the template)
      if (!importedLayouts[layout]) {
        importedLayouts[layout] = () => import(`@/layouts/${layout}.vue`);
      }
      return importedLayouts[layout];
    },
  },
};
</script>
